function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#000000",
    d: "M 135.5,63.5 C 177.835,63.3333 220.168,63.5 262.5,64C 277.473,71.9243 280.973,83.4243 273,98.5C 269.731,101.883 265.897,104.383 261.5,106C 222.167,106.333 182.833,106.667 143.5,107C 122.877,111.289 110.711,123.789 107,144.5C 106.333,218.5 106.333,292.5 107,366.5C 110.833,387.667 123.333,400.167 144.5,404C 218.5,404.667 292.5,404.667 366.5,404C 385.142,401.026 397.309,390.526 403,372.5C 404.298,332.866 404.964,293.199 405,253.5C 408.069,243.115 415.069,237.448 426,236.5C 436.203,237.095 443.203,242.095 447,251.5C 447.667,292.833 447.667,334.167 447,375.5C 441.106,405.796 424.273,427.63 396.5,441C 389.731,443.776 382.731,445.776 375.5,447C 295.5,447.667 215.5,447.667 135.5,447C 105.204,441.106 83.3705,424.273 70,396.5C 67.224,389.731 65.224,382.731 64,375.5C 63.3333,295.5 63.3333,215.5 64,135.5C 69.568,103.93 87.068,81.7634 116.5,69C 122.911,66.9853 129.244,65.152 135.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#000000",
    d: "M 441.5,84.5 C 458.007,82.5217 467.34,89.6883 469.5,106C 469.344,110.457 468.178,114.624 466,118.5C 399.473,185.361 332.639,251.861 265.5,318C 257.475,321.41 249.809,320.743 242.5,316C 212.333,285.833 182.167,255.667 152,225.5C 143.994,206.51 149.994,194.843 170,190.5C 174.87,190.895 179.37,192.395 183.5,195C 207.347,219.014 231.347,242.847 255.5,266.5C 315.32,207.18 374.986,147.68 434.5,88C 436.925,86.7874 439.259,85.6207 441.5,84.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.02d75811cbac6fa41fb977e23947b79d.svg";
export { ForwardRef as ReactComponent };